import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import { Navigate } from 'react-router-dom';

import type { ComponentOrMapping } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';
import { getItemCreatePath } from '@eshop/pages/dashboard/items/itemCreationRoutes.ts';

const SpacesManagementPage = lazyWithRetry(() => import('@erp/spaces/pages/SpacesManagementPage.tsx'));
const DashBoardCatalogue = lazyWithRetry(() => import('@eshop/pages/dashboard/items/DashBoardCatalogue.tsx'));
const RoleManagementPage = lazyWithRetry(() => import('@erp/staff/pages/RoleManagementPage.tsx'));
const ErpItemEditorPage = lazyWithRetry(() => import('@erp/pages/ErpItemEditorPage.tsx'));
const ItemCreationWizardPage = lazyWithRetry(() => import('@eshop/pages/dashboard/items/ItemCreationWizardPage.tsx'));

const ErpItemEditorRoute = () => (
  <RequireStaff render={() => <ErpItemEditorPage />} />
);
const LegacyErpItemCreateRedirect = () => <Navigate to={getItemCreatePath('erp')} replace />;

const DashBoardCatalogueERP = () => (
  <DashBoardCatalogue from={'erp'} />
);

const servicesNode: ComponentOrMapping = {
  spaces: { component: SpacesManagementPage },
  catalogue: { component: DashBoardCatalogueERP },
  'catalogue/create': { component: () => <RequireStaff render={() => <ItemCreationWizardPage />} /> },
  'catalogue/edit': { component: LegacyErpItemCreateRedirect },
  'catalogue/edit/:id': { component: ErpItemEditorRoute },
  roles: { component: RoleManagementPage },
};

const servicesRoutes: ComponentOrMapping = {
  erp: {
    services: servicesNode,
  },
};

export default servicesRoutes;
